import Swiper from "swiper";

import {
  getParentByClass,
  validateEmailInput,
  validateTeleInput,
} from "../../../resources/js/helper/helper";

(function () {
  const mbEmailFunnels = document.querySelectorAll(".mb-contact-funnel");

  for (let i = 0; i < mbEmailFunnels.length; i++) {
    /**
     * Init slider
     */
    const currentSwiper = new Swiper(mbEmailFunnels[i], {
      loop: false,
      slidesPerView: 1,
      allowTouchMove: false,
      on: {
        slideChange: function (swiper) {
          if (
            swiper.activeIndex > 0 &&
            swiper.activeIndex < swiper.slides.length - 1
          ) {
            swiper.el.classList.add("mb-contact-funnel-go-back");
          } else {
            swiper.el.classList.remove("mb-contact-funnel-go-back");
          }

          if (swiper.activeIndex == swiper.slides.length - 2) {
            swiper.el.classList.add("mb-contact-funnel-send");
          } else {
            swiper.el.classList.remove("mb-contact-funnel-send");
          }
        },
        reachEnd: function (swiper) {
          swiper.el.classList.remove(
            "mb-contact-funnel-send",
            "mb-contact-funnel-go-back"
          );
          swiper.el.classList.add("mb-contact-funnel-end");
        },
      },
    });

    const currentSwiperEle = currentSwiper.el;

    const backButton = currentSwiper.el.querySelector(
      ".mb-contact-funnel-back"
    );
    const nextButton = currentSwiper.el.querySelector(
      ".mb-contact-funnel-next"
    );

    const sendButton = currentSwiper.el.querySelector(
      ".mb-contact-funnel-send"
    );

    /**
     * Click BackButton
     */
    backButton.addEventListener("click", (e) => {
      currentSwiper.slidePrev();
    });

    /**
     * Click NextButton
     */
    nextButton.addEventListener("click", (e) => {
      const activeSlide = currentSwiper.slides[currentSwiper.activeIndex];
      const currentInputs = activeSlide.querySelectorAll("input, textarea");
      let goToNextStep = true;

      // check for requiered inputs on current slide
      for (let ci = 0; ci < currentInputs.length; ci++) {
        goToNextStep = validateInput(currentInputs[ci]) ? goToNextStep : false;
      }

      // go to next slide
      if (goToNextStep) currentSwiper.slideNext();
    });

    /**
     * Click sendButton
     */
    sendButton.addEventListener("click", (e) => {
      // check disabled state
      if (sendButton.classList.contains("disabled")) return;

      // check for requiered inputs on current slide
      const activeSlide = currentSwiper.slides[currentSwiper.activeIndex];
      const currentInputs = activeSlide.querySelectorAll("input, textarea");
      let couldBeSend = true;

      for (let ci = 0; ci < currentInputs.length; ci++) {
        couldBeSend = validateInput(currentInputs[ci]) ? couldBeSend : false;
      }

      // stop if input isn´t valide
      if (!couldBeSend) return;

      sendButton.classList.add("disabled");

      // get email content
      const allInputs = currentSwiperEle.querySelectorAll("input, textarea");
      let emailText = "";

      for (let ai = 0; ai < allInputs.length; ai++) {
        const value = allInputs[ai].value;
        const placeholder = allInputs[ai].placeholder;

        if (value) {
          emailText += placeholder + ": " + value + "\n";
        }
      }

      // send email
      jQuery.ajax({
        type: "POST",
        url: globalvars.ajaxurl,
        data: {
          action: "send_contact_mail_ajaxhandler",
          nonce: globalvars.ajax_nonce,
          text: emailText,
          to: sendButton.dataset.mailto,
        },
        beforeSend: function () {},
        complete: function () {},
        success: function (data) {
          sendButton.classList.remove("disabled");
          currentSwiper.slideNext();
        },
        error: function (MLHttpRequest, textStatus, errorThrown) {
          console.log(textStatus, errorThrown);
        },
      });
    });

    /**
     * Validation helper
     */
    function validateInput(input) {
      input.classList.remove("mb-invalid-input");

      let isValid = false;

      if (input.type == "email") {
        isValid = validateEmailInput(input);
      } else if (input.type == "tel") {
        isValid = validateTeleInput(input);
      } else {
        isValid =
          (input.required && input.value) || (!input.required && input.value);
      }

      const mbFormfield = getParentByClass(input, "mb-formfield");
      if (mbFormfield) {
        mbFormfield.classList.remove("mb-invalid-formfield");

        if (!isValid) {
          mbFormfield.classList.add("mb-invalid-formfield");
        }
      }

      if (!isValid) {
        input.classList.add("mb-invalid-input");
      }

      return isValid;
    }
  }
})();
